import StudentNotesDetailsWrapper from "@/pages/cursisten/$studentId/notes/StudentNoteDetailsWrapper"
import { checkPermissions } from "@/utils/checkPermissions"
import { createFileRoute, useParams } from "@tanstack/react-router"

export const Route = createFileRoute(
  "/beheer/cursisten/$studentId/notities/$noteThreadId/",
)({
  component: RouteComponent,
  beforeLoad: () => checkPermissions("read", "students"),
})

function RouteComponent() {
  const { studentId, noteThreadId } = useParams({
    from: "/beheer/cursisten/$studentId/notities/$noteThreadId/",
  })

  return (
    <StudentNotesDetailsWrapper
      studentId={Number(studentId)}
      noteThreadId={Number(noteThreadId)}
    />
  )
}
